
	<div class="row" [hidden]="msgHead.msg == ''">
		<div class="col-lg-8 col-md-6 col-xs-12">
			<alert [alert]="msgHead"></alert>
		</div>
	</div>
	<div *ngIf="hasAccess" class="row">
		<div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
			<form [formGroup]="form" novalid>
				<div class="row">
					<div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
						<div class="form-group">
                            <p class="custom-label">Email Address</p>
							<input type="text" [(ngModel)]="fobj.email" formControlName="email" class="form-control" placeholder="Email" title="Email Address">
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
			<button type="button" class="btn btn-large btn-primary" (click)="invite()">Invite</button>
		</div>
	</div>
	  <div *ngIf="hasAccess" class="row">
		<div class="col-lg-6 col-md-6 col-xs-12">
			<alert [alert]="msg" style="display:block;"></alert>
		</div>
	  </div>
	<div *ngIf="hasAccess" class="row">
		<div class="col-lg-8 col-md-12 col-xs-12">
			<div class="card">
				<table class="table">
					<thead>
						<tr>
							<th>Name</th>
							<th>Email</th>
							<th>Status</th>
							<th>Roles</th>
							<th>Owner</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of data; let i = index">
							<td style="width:25%;">{{user.userId != row.userId ? row.firstName + ' ' +row.lastName : 'You'}}</td>
							<td style="width:25%;">{{row.email}}</td>
							<td style="width:10%;">{{row.status}}</td>
							<td>
								<span class="tag" *ngFor="let role of row.roles; let j = index" style="padding: 2px 4px; display: inline-block; margin-bottom: 3px; margin-right: 3px;">{{role}} <span (click)="removeRole(row,j)" class="tag-close">x</span></span>
								<span title="Add Role" class="dropdown" [class.open]="row.openAddRole" [offClick]="clickedOutside">
						  <span style="font-size:10px;" class="glyphicon glyphicon-plus" style="cursor:pointer;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" (click)="openAddRole(row)" >
						  </span>
								<ul class="dropdown-menu">
									<li *ngFor="let r of roles"><a (click)="addRole(row,r)">{{r}}</a></li>
								</ul>
								</span>
							</td>
							<td style="width:10%;">{{row.owner}}</td>
							<td style="width:5%;">
								<span title="Remove User" class="glyphicon glyphicon-trash" style="cursor:pointer;" aria-hidden="true" (click)="removeUser(row)"></span>
								<span *ngIf="row.status=='invite'" title="Re-invite User" class="glyphicon glyphicon-envelope" style="margin-left:5px;" aria-hidden="true" (click)="reInvite(row)"></span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
   